/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState, useContext} from 'react';
import firebase from "firebase/compat/app";
import "firebase/compat/analytics";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import {
  Switch,
  Route,
  Link,
  useRouteMatch,
} from "react-router-dom";
import { uid } from 'uid';
import i18next from 'i18next';
import UserContext from '../context/UserContext';
import CampaignContext from '../context/CampaignContext';
import SystemContext from '../context/SystemContext';
import {isCampaignOfSystem, SYSTEMS} from '../utils/gameSystem';
import VtmCampaignList from '../vtm/components/VtmCampaignList';
import Characters from './Characters';
import NewCampaignForm from '../components/NewCampaignForm';
import {init} from '../utils/initFirebase'
import {getCampaignHue, getCampaignInitials} from '../utils/campaignVisual';
import '../styles/campaigns.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {useHistory} from "react-router-dom";

init();
const db = firebase.firestore();


const Campaigns = (props) => {
  const [campaigns, setCampaigns] = useState([]);
  const [favorites, setFavorites] = useState([]);
  const [campaign, setCampaign] = useState({
    uid: null,
    idUserDm: null,
    name: null,
    invitationCode: null,
    createdAt: null
  });
  const [invitationJoinCode, setInvitationJoinCode] = useState(undefined);
  const [campaignToJoin, setCampaignToJoin] = useState(undefined);
  let match = useRouteMatch();
  const history = useHistory();

  const {user} = useContext(UserContext)
  const gameSystem = useContext(SystemContext);
  const contextValue = {
    campaign,
    updateCampaign: setCampaign
  }

  useEffect( () => {
    if(user.uid) {
      db.collection('users').doc(user.uid).get().then(doc => {
        if(doc.exists && doc.data().favoriteCampaigns) {
          setFavorites(doc.data().favoriteCampaigns);
        }
      });
    }
  }, []);

  useEffect( () => {
    if(user.uid && campaigns.length === 0) {
      getCampaignByCharacter();
      // const savedCampaignsList = getValueOnLocalStorage('campaignsList');
      // const savedUserUid = getValueOnLocalStorage('userUid');
      // if(!savedCampaignsList || savedUserUid !== user.uid) {
      //   getCampaignByCharacter();
      // } else {
      //   setCampaigns(savedCampaignsList);
      // }
    }
  }, []);

  useEffect( () => {
    if(campaign && campaign.uid && campaignToJoin) {
      history.push(`${match.url}/${campaign.uid}`);
    }
  }, [campaign]);

  const getCampaignByCharacter = async () => {
    const listUidCampaignByCharacter = [];
    await db.collection('characters').where('idUser', '==', user.uid).get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          if(!listUidCampaignByCharacter.some(element => (doc.data().idCampaign === element))) {
            listUidCampaignByCharacter.push(doc.data().idCampaign)
          }
      });
      getCampaignForCharacter(listUidCampaignByCharacter)
    })
    .catch(err => {
      console.log(err.message)
    })
  }

  const getCampaignForCharacter = async (uidList) => {
    const campaignsByCharacter = [];
    for( let i = 0; i < uidList.length; i +=1) {
      await db.collection('campaigns').doc(uidList[i]).get()
        .then(queryCampaign => {
          if(queryCampaign.data().active && isCampaignOfSystem(queryCampaign.data(), gameSystem)) {
            campaignsByCharacter.push(queryCampaign.data());
          }
        })
      .catch(err => {
        console.log(err.message)
      })
    }
    getCampaigns(campaignsByCharacter)
  }

  const getCampaigns = (campaignsByCharacter) => {
    const listCampaigns = [...campaignsByCharacter];
    db.collection('campaigns').where('idUserDm', '==', user.uid).where('active', '==', true).get()
      .then(querySnapshot => {
        querySnapshot.forEach( doc => {
          if(isCampaignOfSystem(doc.data(), gameSystem) && !campaignsByCharacter.some(element => (doc.data().uid === element.uid))) {
            listCampaigns.push(doc.data())
          }
        });
      setCampaigns(listCampaigns);
      // setValueOnLocalStorage('campaignsList',listCampaigns);
      // setValueOnLocalStorage('userUid',user.uid);
    })
    .catch(err => {
      console.log(err.message)
    })
  }

  const getInvitationCodeGame = () => {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < 6; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  const sendGame = async (name) => {
    // const savedCampaignsList = getValueOnLocalStorage('campaignsList');
    const savedCampaignsList = [...campaigns];
    const invitationCode = getInvitationCodeGame();
    const gameUid = uid();
    const data = {
      createdBy: user.displayName,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      lastUpdateAt: firebase.firestore.FieldValue.serverTimestamp(),
      idUserDm: user.uid,
      invitationCode: invitationCode,
      name: name,
      uid: gameUid,
      system: gameSystem,
      active: true,
      clickStat: true,
      renameCharacter: false,
      hideValueCharacterStatsOnChat: false,
    };
    savedCampaignsList.push(data)
    await db.collection('campaigns').doc(gameUid).set(data).then(res => {
      toast.success(`${name} ${i18next.t('was created with success')}`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setCampaigns(savedCampaignsList);
      firebase.analytics().setUserId(user.uid);
      firebase.analytics().setUserProperties({
        name: user.displayName,
        uid: user.uid,
      });
      firebase.analytics().logEvent('campaignCreation', {
        campaignCreatedBy: user.uid,
        campaignInvitationCode: invitationCode,
        campaignName: name,
      });
      // setValueOnLocalStorage('campaignsList',savedCampaignsList);
      setCampaign(data)
      history.push(`${match.url}/${gameUid}`);
    }).catch(e => {
      console.log(e)
    });
  }

  const toggleFavorite = (e, campaignUid) => {
    e.preventDefault();
    e.stopPropagation();
    const updated = favorites.includes(campaignUid)
      ? favorites.filter(id => id !== campaignUid)
      : [...favorites, campaignUid];
    setFavorites(updated);
    db.collection('users').doc(user.uid).set({ favoriteCampaigns: updated }, { merge: true });
  }

  const joinCampaignByInvitationCode = async (code = invitationJoinCode) => {
    await db.collection('campaigns').where('invitationCode', '==', code).where('active', '==', true).get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          if(!isCampaignOfSystem(doc.data(), gameSystem)) {
            toast.error(i18next.t('campaign of another game system'), {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: true,
            });
            return;
          }
          setCampaignToJoin(doc.data());
          setCampaign(doc.data());
        });
      })
      .catch(err => {
        console.log(err.message)
      })
  }

  return (
    <div className='mainContainer'>
      <CampaignContext.Provider value={contextValue}>
        <Switch>
          <Route path={`${match.url}/:campaignIdUrl`}>
            <Characters/>
          </Route>
          <Route path={match.path}>
            {gameSystem === SYSTEMS.VTM5 ? (
              <VtmCampaignList
                campaigns={campaigns}
                favorites={favorites}
                userUid={user.uid}
                baseUrl={match.url}
                onSelect={setCampaign}
                onToggleFavorite={toggleFavorite}
                joinCode={invitationJoinCode || ''}
                onJoinCodeChange={code => setInvitationJoinCode(code.toUpperCase())}
                onJoin={code => joinCampaignByInvitationCode(code)}
                onCreate={sendGame}
              />
            ) : (
            <div className='campaignsPage'>
              <h1>{i18next.t('my campaign')}</h1>

              <div className='campaignGrid'>
                {campaigns.length === 0 && (
                  <div className='campaignsEmpty'>{i18next.t('no campaign yet')}</div>
                )}
                {[...campaigns].sort((a, b) => {
                  const aFav = favorites.includes(a.uid) ? 0 : 1;
                  const bFav = favorites.includes(b.uid) ? 0 : 1;
                  return aFav - bFav;
                }).map(c => {
                  const isDm = c.idUserDm === user.uid;
                  const isFavorite = favorites.includes(c.uid);
                  const createdAt = c.createdAt && c.createdAt.toDate ? c.createdAt.toDate() : null;
                  return (
                  <Link
                    key={c.uid}
                    className={`campaignCard${isFavorite ? ' favorite' : ''}`}
                    onClick={() => setCampaign(c)}
                    to={`${match.url}/${c.uid}`}
                  >
                    <div
                      className={`campaignCardCover${c.coverPicture ? ' hasImage' : ''}`}
                      style={{
                        '--campaign-hue': getCampaignHue(c.uid),
                        backgroundImage: c.coverPicture ? `linear-gradient(to top, rgba(0,0,0,0.35), transparent 60%), url(${c.coverPicture})` : undefined,
                      }}
                    >
                      <span className='campaignCardMonogram'>{getCampaignInitials(c.name)}</span>
                      <button
                        className={`campaignFavBtn${isFavorite ? ' active' : ''}`}
                        onClick={(e) => toggleFavorite(e, c.uid)}
                        title="Favori"
                      >★</button>
                    </div>
                    <div className='campaignCardBody'>
                      <span className='campaignCardName'>{c.name}</span>
                      <div className='campaignCardMeta'>
                        <span className={`campaignCardBadge${isDm ? '' : ' player'}`}>
                          {isDm ? 'MJ' : i18next.t('player')}
                        </span>
                        {!isDm && c.createdBy && <span className='campaignCardBy'>{c.createdBy}</span>}
                        {createdAt && <span className='campaignCardDate'>{createdAt.toLocaleDateString(i18next.language, {month: 'short', year: 'numeric'})}</span>}
                      </div>
                      {isDm && c.invitationCode && (
                        <div className='campaignCardFooter'>
                          <span>{i18next.t('invitation code')}</span>
                          <span className='campaignCardCode'>{c.invitationCode}</span>
                        </div>
                      )}
                    </div>
                  </Link>
                  );
                })}
              </div>

              <div className='campaignActions'>
                <div className='campaignActionBlock'>
                  <span className='campaignActionTitle'>{i18next.t('join campaign')}</span>
                  <form onSubmit={(e) => { e.preventDefault(); if(invitationJoinCode) joinCampaignByInvitationCode(); }}>
                    <input
                      name="campaignName"
                      type="text"
                      placeholder={i18next.t('invitation code')}
                      value={invitationJoinCode || ''}
                      onChange={(e) => setInvitationJoinCode(e.target.value)}
                    />
                    <input type="submit" value={i18next.t('search')} />
                  </form>
                </div>

                <div className='campaignActionBlock'>
                  <span className='campaignActionTitle'>{i18next.t('create campaign')}</span>
                  <NewCampaignForm createCampaign={(campaignName) => sendGame(campaignName)} />
                </div>
              </div>
            </div>
            )}
          </Route>
        </Switch>
      </CampaignContext.Provider>
      <ToastContainer
        progressClassName="toastProgress"
        bodyClassName="toastBody"
        position="top-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default Campaigns